<template>
  <div class="accordion-item">
    <div class="accordion-header" :class="{'cursor-text': alwaysDisplay || disabled}" :aria-expanded="alwaysDisplay || expanded" @click="toggleExpanded()">
      <span class="icon" :class="{'disable-arrow': alwaysDisplay || disabled}" :aria-hidden="alwaysDisplay || !expanded">
       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.29289 6.29289C3.68342 5.90237 4.31658 5.90237 4.70711 6.29289L10 11.5858L15.2929 6.29289C15.6834 5.90237 16.3166 5.90237 16.7071 6.29289C17.0976 6.68342 17.0976 7.31658 16.7071 7.70711L10.7071 13.7071C10.3166 14.0976 9.68342 14.0976 9.29289 13.7071L3.29289 7.70711C2.90237 7.31658 2.90237 6.68342 3.29289 6.29289Z" fill="#526C82" fill-opacity="0.8"/>
      </svg>
      </span>
      <span class="accordion-title">
        <slot name="name"></slot>
      </span>
    </div>
    <div class="accordion-content" v-show="alwaysDisplay || !hidden">
      <slot name="content"></slot>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseAccordion',
  props: {
    disabled: { type: Boolean, default: false },
    alwaysDisplay: { type: Boolean, default: false }
  },
  data () {
    return {
      expanded: false,
      hidden: true,
      timer: null
    }
  },
  methods: {
    toggleExpanded () {
      if (this.disabled) return

      this.expanded = !this.expanded

      if (this.expanded) {
        this.hidden = false
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
      } else {
        if (!this.timer) {
          this.timer = setTimeout(() => {
            this.hidden = true
            this.timer = null
          }, 10)
        }
      }
    }
  }
}
</script>
